import getSearchParamsString from '../../utils/get-search-params-string';

export default {
  index: {
    pattern: () => ``,
    url: () => `/${getSearchParamsString()}`,
  },
  userArchetypes: {
    pattern: () => `/user-archetypes`,
    url: () => `/user-archetypes${getSearchParamsString()}`,
  },
  siteCategory: {
    pattern: () => `/specify-category`,
    url: () => `/specify-category${getSearchParamsString()}`,
  },
  gallery: {
    pattern: () => `/templates/`,
    url: () => `/templates/${getSearchParamsString()}`,
  },
  siteName: {
    pattern: () => `/site-name`,
    url: () => `/site-name${getSearchParamsString()}`,
  },
  businessName: {
    pattern: () => `/business-name`,
    url: () => `/business-name${getSearchParamsString()}`,
  },
  businessDetails: {
    pattern: () => `/business-details`,
    url: () => `/business-details${getSearchParamsString()}`,
  },
  templateDetails: {
    pattern: () => `/template/:templateSlug`,
    url: ({ templateSlug }) => `/template/${templateSlug}${getSearchParamsString()}`,
  },
  createSite: {
    pattern: () => `/:step?/:templateSlug?/create`,
    url: () => `create${getSearchParamsString()}`,
  },
  platformSelector: {
    pattern: () => `/platform`,
    url: () => `/platform${getSearchParamsString()}`,
  },
  useTemplate: {
    pattern: () => `/use-template/:templateSlug`,
    url: ({ templateSlug }) => `/use-template/${templateSlug}${getSearchParamsString()}`,
  },
  legacyTemplates: {
    pattern: () => `/legacy-templates`,
    url: () => `/legacy-templates${getSearchParamsString()}`,
  },
  howToBuild: {
    pattern: () => `/select-how-to-build`,
    url: () => `/select-how-to-build${getSearchParamsString()}`,
  },
};
